import {Pinia} from 'pinia'
import {useLocalPreferenceStore} from '@toolify/client/src/stores/LocalPreferenceStore/useLocalPreferenceStore'

export function hydrateLocalPreferenceRouterHookFactory(pinia: Pinia) {
  return async function hydrateLocalPreferenceRouterHook(): Promise<void> {
    await useLocalPreferenceStore(pinia).hydrate()
  }
}
